import { produce } from 'immer';
import _ from 'lodash';

import { DOC_EXTRACTION_MAPPING_ACTION_TYPE } from 'store/system/actions/documentExtractionMapping.actions';

const initialState = {
  loanFields: {},
  enumTypes: {},
  docExtractionFields: {},
  docExtractionMapping: {},
};

const documentExtractionMappingReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case DOC_EXTRACTION_MAPPING_ACTION_TYPE.GET_LOAN_FIELDS: {
        draft.loanFields = payload.categories || {};
        draft.enumTypes = payload.enumTypes || {};
        break;
      }

      case DOC_EXTRACTION_MAPPING_ACTION_TYPE.GET_DOC_EXTRACTION_FIELDS_BY_DOC_TYPE_ID: {
        const { documentTypeId, data } = payload;

        draft.docExtractionFields[documentTypeId] = data;
        break;
      }

      case DOC_EXTRACTION_MAPPING_ACTION_TYPE.GET_MAPPED_DOCUMENT_TYPES_LIST: {
        draft.docExtractionMapping = payload;
        break;
      }

      case DOC_EXTRACTION_MAPPING_ACTION_TYPE.ADD_NEW_DOC_EXTRACTION_MAPPING:

      case DOC_EXTRACTION_MAPPING_ACTION_TYPE.GET_DOC_EXTRACTION_MAPPING_BY_DOC_TYPE_ID: {
        draft.docExtractionMapping[payload.documentTypeId] = payload;
        break;
      }

      case DOC_EXTRACTION_MAPPING_ACTION_TYPE.EDIT_DOC_EXTRACTION_MAPPING: {
        const { documentTypeId, fieldsMapping } = payload;
        const filledFields = _.omitBy(fieldsMapping, item => !item.propertyPath);

        draft.docExtractionMapping[documentTypeId].fieldsMapping = filledFields;
        break;
      }

      case DOC_EXTRACTION_MAPPING_ACTION_TYPE.DELETE_DOC_EXTRACTION_MAPPING: {
        delete draft.docExtractionMapping[payload];
        break;
      }

      default:
        return state;
    }
  });

export default documentExtractionMappingReducer;
